<script>
    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    // Import primevue components
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';

    export default {
        mixins: [mixin],
        components: {
            DataTable,
            Column,
        },
        props: {
            data: Object,
            filterItems: Array,
        },
        data() {
            return {
                facetAlias: 'status_extern_label',
                facetAliasTocollectbyyou: 'voor_opdrachtgever_te_incasseren',
                facetAliasCostsdossier: 'kosten_totaal_inc_btw',
                facetAliasTotaltocollect: 'vordering_debiteur_inc_btw',
                facetAliasTotalpaidafterhandover: 'betaald_totaal_na_indiening',
                facetAliasTobepaid: 'vordering_debiteur_openstaand_inc_btw',
                facetAliasSumsreceived: 'bedrag_door_u_ontvangen_inc_btw',
                facetAliasSumspaid: 'bedrag_door_u_betaald_inc_btw',
                columns: [
                    {
                        label: this.$store.getters.getText('dashboardTableStatus'),
                        field: 'status',
                        frozen: true,
                    },
                    {
                        label: this.$store.getters.getText('dashboardWidgetAmount'),
                        field: 'count',
                        type: 'amount',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableTocollectbyyou'),
                        field: 'tocollectbyyou',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableCostsdossier'),
                        field: 'costsdossier',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableTotaltocollect'),
                        field: 'totaltocollect',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableTotalpaidafterhandover'),
                        field: 'totalpaidafterhandover',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableTobepaid'),
                        field: 'tobepaid',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardWidgetSumsReceived'),
                        field: 'sumsreceived',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardWidgetSumsPaid'),
                        field: 'sumspaid',
                        type: 'currency',
                    },
                ]
            }
        },
        computed: {
            facetsSet() {
                return this.data && this.data.facets && this.data.facets.length;
            },
            dataSet() {
                if (!this.facetsSet) return [];
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return [];

                let statuses = [...facet.options];
                const activeFilter = this.filterItems.find(filter => filter.Key === this.facetAlias);
                if (activeFilter) statuses = statuses.filter(status => status.valueAlias === activeFilter.Values[0]);

                const dataSet = statuses.map(status => {
                    if (!status.filteredAmount || !status.sums) return null;
                    return {
                        status: status.valueAlias,
                        count: status.filteredAmount,
                        tocollectbyyou: status.sums[this.facetAliasTocollectbyyou],
                        costsdossier: status.sums[this.facetAliasCostsdossier],
                        totaltocollect: status.sums[this.facetAliasTotaltocollect],
                        totalpaidafterhandover: status.sums[this.facetAliasTotalpaidafterhandover],
                        tobepaid: status.sums[this.facetAliasTobepaid],
                        sumsreceived: status.sums[this.facetAliasSumsreceived],
                        sumspaid: status.sums[this.facetAliasSumspaid],
                    };
                }).filter(s => s);
                return dataSet.sort((a, b) => b.count - a.count);
            },
            computedColumns() {
                return this.columns;
            },
        },
        methods: {
            freezeColumn(event, selectedColumn) {
                event.preventDefault();
                const column = this.columns.find(column => column.label === selectedColumn.label);
                column.frozen = !column.frozen;
            }
        },
    };
</script>

<template>
    <DataTable v-if="dataSet.length"
               ref="dt"
               scrollable
               scrollHeight="500px"
               :virtualScrollerOptions="{ itemSize: 30 }"
               :value="dataSet"
               :pt="{ table: 'table table--small table--datatable is-bordered is-fullwidth' }"
               :exportFilename="`${exportFilename}-${new Date().getTime()}`">
        <Column v-for="column of columns"
                :key="column.field"
                :field="column.field"
                :header="column.label"
                sortable
                :frozen="column.frozen">
            <template #header>
                <span class="icon" v-if="column.field !== 'status'" @click="freezeColumn($event, column)"><i :class="['fa-solid', 'fa-sm', column.frozen ? 'fa-lock' : 'fa-lock-open']"></i></span>
            </template>
            <template #sorticon="slotProps">
                <span :class="['icon', { 'soft-hide': !slotProps.sorted }]"><i :class="['fa-solid', 'fa-sm' , slotProps.sorted && slotProps.sortOrder === 1 ? 'fa-caret-up' : 'fa-caret-down']"></i></span>
            </template>
            <template v-if="column.type === 'currency'" #body="slotProps">
                <p class="has-text-right">{{ toEuro(slotProps.data[column.field], true) }}</p>
            </template>
            <template v-if="column.type === 'date'" #body="slotProps">
                {{ toDateStr(slotProps.data[column.field]) }}
            </template>
            <template v-if="column.type === 'amount'" #body="slotProps">
                <p class="has-text-right">{{ slotProps.data[column.field] }}</p>
            </template>
            <template v-if="column.type === 'link'" #body="slotProps">
                <a :href="column.url + slotProps.data[column.field]">{{ slotProps.data[column.field] }}</a>
            </template>
        </Column>
    </DataTable>
</template>
